var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_has.js
// module id = 17
// module chunks = 1